"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "venarotta": {
    "1bd2d5e9": [{
      "hkey": "a11c0be6",
      "slug": "gimigliano-galleggiano",
      "name": "Gimigliano-Galleggiano",
      "primary": true,
      "skipSearch": false
    }],
    "gimigliano": [{
      "hkey": "a11c0be6",
      "slug": "gimigliano-galleggiano",
      "name": "Gimigliano-Galleggiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "319f812e": [{
      "hkey": "8994710c",
      "slug": "olibra-incinesca",
      "name": "Olibra Incinesca",
      "primary": true,
      "skipSearch": false
    }],
    "olibra": [{
      "hkey": "8994710c",
      "slug": "olibra-incinesca",
      "name": "Olibra Incinesca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0f7e895b": [{
      "hkey": "9c78aa74",
      "slug": "venarotta",
      "name": "Venarotta",
      "primary": true,
      "skipSearch": false
    }],
    "portella": [{
      "hkey": "9c78aa74",
      "slug": "venarotta",
      "name": "Venarotta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;